import { render } from "./ButtonSimple.vue?vue&type=template&id=ee502d94&scoped=true&ts=true"
import script from "./ButtonSimple.vue?vue&type=script&lang=ts"
export * from "./ButtonSimple.vue?vue&type=script&lang=ts"

import "./ButtonSimple.vue?vue&type=style&index=0&id=ee502d94&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee502d94"]])

export default __exports__